import ApiService from "./apiService";

export async function getAllPapersByClass(body) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/class/viewQuizzes`;
    apiObject.body = body;
    return await ApiService.callApi(apiObject);
}
export async function getAllPapersByCourse(id) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/course/viewQuizzes/`+id;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function startQuize(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/startQuiz`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function startCourseQuiz(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/course/startQuiz`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}


export async function saveAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/saveAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function saveCourseAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/course/saveAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function endAndSubmitQuize(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/endSubmitQuiz`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function endAndSubmitCourseQuiz(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/course/endSubmitQuiz`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}


export async function viewTriedQuizzes(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/student/viewTriedQuizzes`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function viewLeaderShipBoard(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/view/leaderShipBoard`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function viewCourseLeaderShipBoard(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/course/view/leaderShipBoard`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function compareAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/student/compareAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function compareCourseAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `quiz/student/course/compareAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function submitWrittenPaper(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/submit/writtenAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function submitWrittenCoursePaper(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/submit/course/writtenAnswers`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function saveWrittenPaperAnswers(data) {
    const apiObject = {};
    apiObject.method = 'PUT';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/add/writtenAnswer`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}

export async function saveWrittenPaperCourseAnswers(data) {
    const apiObject = {};
    apiObject.method = 'PUT';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/add/course/writtenAnswer`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function getWrittenPaperAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/view/submittedEssayPaper`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function getWrittenCoursePaperAnswers(data) {
    const apiObject = {};
    apiObject.method = 'POST';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/course/view/submittedEssayPaper`;
    apiObject.body = data;
    return await ApiService.callApi(apiObject);
}
export async function deleteWrittenPaperAnswers(id) {
    const apiObject = {};
    apiObject.method = 'DELETE';
    apiObject.authentication = true;
    apiObject.endpoint = `student/essay/remove/writtenAnswer/${id}`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}

export async function getCertificate(studentId, type) {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `application/issue-certificate/${studentId}/type/${type}`;
    return await ApiService.callApi(apiObject);
}
/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
APPLAB */
